<script setup>
import {  setCancelBankAPI,getModifyBankOrderAPI } from '@/apis/wallet'
import { useI18n } from 'vue-i18n'
const { t } = useI18n();
const props = defineProps(['model','id'])
const emits= defineEmits(['Close'])
const setCancel=async ()=>{
    const res = await setCancelBankAPI({order_no:props.id})
    if (res.code == 0) {
        ElMessage({ type: 'success', message: t('number40') });
        handleClose()
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
const isMobile = ref(false);//false代表pc
onMounted(() => {
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    console.log('Is mobile device:', isMobile.value);
    
})
const setModifyBankOrder=async ()=>{
    
    const res = await getModifyBankOrderAPI({order_no:props.id,status:2})
    if (res.code == 0) {
        ElMessage({ type: 'success', message: t('number109')});
        handleClose()
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
const handleClose=()=>{
    emits('Close', false)
}
</script>
<template>
    
    <div v-if="isMobile==false">
            <el-dialog v-model="props.model" :title="t('home3')" width="350" :before-close="handleClose">
                <div class="dialogcontent">
                    <div class="title"> {{$t('number49')}}：{{ props.id }}</div>
                  

                </div>
                <template #footer>
                    <div class="dialog-footer">
                        <el-button type="primary" @click="setCancel()">
                           {{$t('number99')}}
                           
                        </el-button>
                        <el-button type="primary" @click="setModifyBankOrder()">
                            {{$t('number108')}}
                           
                        </el-button>
                    </div>
                </template>
            </el-dialog>
      </div>
      <div v-else>
        <el-drawer v-model="props.model" :title="t('home3')" show-close :with-header="true" direction="btt" :before-close="handleClose"
        size="30%">
            <!-- <el-dialog v-model="props.model" :title="t('home3')" width="350" :before-close="handleClose"> -->
                <div class="dialogcontent">
                    <div class="title"> {{$t('number49')}}：{{ props.id }}</div>
                  

                </div>
                <template #footer>
                    <div class="dialog-footer">
                        <el-button type="primary" @click="setCancel()">
                           {{$t('number99')}}
                           
                        </el-button>
                        <el-button type="primary" @click="setModifyBankOrder()">
                            {{$t('number108')}}
                           
                        </el-button>
                    </div>
                </template>
            <!-- </el-dialog> -->
             </el-drawer>
      </div>
</template>
<style scoped lang="scss">

</style>